import React from 'react';
import { ICreateBudget } from '../../../@types';
import EditIcon from '../../../assets/icons/EditIcon';
import { getBudgetHistory } from '../../../backend-services';
import { formatMoney } from '../../../utils';
import { GroupButton } from '../../common';
import { EditBudget } from './edit';
import PageLoader from '../../common/PageLoader';
import { Page } from '@react-pdf/renderer';


interface ViewBudgetProps {
  monthYear: string;
  allocatedBudget: any;
  amount?:number;
}

export const ViewBudget: React.FC<ViewBudgetProps> = ({ monthYear, allocatedBudget, amount}) => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [showEditTab, setShowEditTab] = React.useState(false);

  const [budget, setBudget] = React.useState<ICreateBudget>({
    monthYear: '',
    allocatedBudget: 0,
    amount:0,
  });
    
  const handleBudgets = async () => {
    setIsLoading(true);
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth() + 1;
    const currentYear = currentDate.getFullYear();
    const monthYear = `${currentMonth.toString().padStart(2, '0')}-${currentYear}`;
    try {
      const data = await getBudgetHistory(monthYear, monthYear);
      setIsLoading(false)
      console.log('Budget data:', data);
      setIsLoading(false);

      const budgetForMonthYear = data.find((budget: { monthYear: string }) => budget.monthYear === monthYear);

      if (budgetForMonthYear) {
        setBudget({
          monthYear: budgetForMonthYear.monthYear,
          allocatedBudget: budgetForMonthYear.allocatedBudget,
          amount: budgetForMonthYear.amount,
        });
      }
    } catch (e) {
      setIsLoading(false);
    }
  };

  React.useEffect(() => {
    handleBudgets();
  }, []);

  

  const getMonthFromYear = (yearMonth: string) => {
    const [month, year] = yearMonth.split('-');
    const date = new Date(`${year}-${month}-01`);
    const monthWord = date.toLocaleString('en-NG', { month: 'long' });
    return monthWord;
  };

  return (
    <div className='flex justify-center'>
      <div className="bg-[#FFFFFF] w-[350px] mx-[-40px] min-h-screen sm:w-full lg:ml-[-1em] lg:h-screen mt-[-1.4em]  md:mt-[-1em] lg:mt-[-1em] "> 
      {!showEditTab ? (
        <>
        {isLoading ? <PageLoader></PageLoader> : <>
        <h1 className="lg:text-[20px] font-semibold lg:font-semibold md:pl-[24px] pt-[20px] md:pt-[24px] pl-[20px] lg:pl-[64px] lg:pt-[55px]">Expense Budget</h1>
          <p className="lg:text-[16px] lg:font-sm pl-[20px] md:pl-[24px] lg:pl-[64px] lg:pt-[7px] pb-[10px] md:pb-[24px] xl:pb-0">Set a monthly budget for your expenses.</p>
          <hr className="lg:mt-[1em] lg:w-full" />
          <div className="mx-[20px] sm:w-[344px] h-[160px] bg-[#EDF2F5] lg:ml-[4em] mt-[2em] rounded border">
            <div className="flex items-center gap-[36px] pl-[64px] pt-[55px]">
              <div className="flex flex-col gap-[7px]">
                <h3 className="text-[#000000] text-[16px] pt-[19px] ml-[-2em] font-normal flex items-center mt-[-5em]">
                  Amount:
                  <span className="text-[#000000] font-semibold text-[16px] mt-[3em] ml-[-4em]">
                    {budget.amount ? formatMoney(budget.amount) : formatMoney(budget.allocatedBudget)}
                  </span>
                </h3>
              </div>
              <a
                href="#edit-modal"
                className="inline-flex items-center text-[#044E97] font-medium mt-[-1rem] lg:ml-[5em] xl:ml-[5em] ml-[4em]"
                onClick={() => setShowEditTab(true)}
              >
                <GroupButton
                  buttons={[
                    {
                      text: 'Edit',
                      icon: <EditIcon />,
                      href: '',
                    },
                  ]}
                />
              </a>
            </div>
          </div>
          </>
          }
          
          <div className=''>
            <h3 className="text-[#000000] text-[16px] ml-[3.3em] md:ml-[3.5em] lg:ml-[6em] mt-[-5em] font-normal flex items-center">
              Month:
              <span className="text-[#000000] font-semibold text-[16px] mt-[3em] ml-[-3em]">
                {getMonthFromYear(budget.monthYear)}
              </span>
            </h3>
          </div>
        </>
      ) : (
        <>
          <EditBudget
            onSubmit={function (event: React.FormEvent<HTMLFormElement>): void {
              throw new Error('Function not implemented.');
            }}
            isLoading={false}
            budgetData={budget}
            monthYear={monthYear} allocatedBudget={amount}
          />
        </>
      )}
    </div>
    </div>
    
  );
};

